import { color_red_default, color_white } from "../../../constants/colors";
import ArrowIconLeft from "../../icons/ArrowIconLeft";

const GoBackButton = ({onClick, marginTop, position}) => {

    return (
        <div style={{
            width: 32,
            height: 32,
            borderRadius: "50%",
            backgroundColor: color_white,
            color: color_red_default,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
            marginTop: marginTop ? marginTop : 0,
            position: position ? position : "relative",
        }} 
        onClick={onClick}>
            <ArrowIconLeft
                style={{
                    marginRight: 5,
                }}

            />

        </div>
    )
}


export default GoBackButton;